<template>
    <div class="flex-page">
        <a-form class="form" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-form-item label="类">
                <a-select style="width: 600px" v-model="info.cate1" @change="changeCate1">
                    <a-select-option v-for="(item, key) in cate1List" :key="key" :value="item.id">{{item.name}} （{{item.lat_name}}）</a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item label="科">
                <a-select style="width: 600px" v-model="info.cate2" @change="changeCate2">
                    <a-select-option v-for="(item, key) in cate2List" :key="key" :value="item.id">{{item.name}} （{{item.lat_name}}）</a-select-option>
                </a-select>
            </a-form-item>
            
            <a-form-item label="名称">
                <a-input style="width: 600px" v-model="info.name"></a-input>
            </a-form-item>

            <a-form-item label="拉丁名">
                <a-input style="width: 600px" v-model="info.lat_name"></a-input>
            </a-form-item>
            <a-form-item label="上传人">
                <a-input style="width: 600px" v-model="info.shangchuanren" ></a-input>
            </a-form-item>
            <a-form-item label="所有人">
                <a-input style="width: 600px" v-model="info.suoyouren" ></a-input>
            </a-form-item>
            <a-form-item label="产地">
                <a-textarea style="width: 600px" v-model="info.chandi" ></a-textarea>
            </a-form-item>
            <a-form-item label="尺寸复核人" v-if="info.status == 1">
                <a-input style="width: 600px" v-model="info.fuheren" ></a-input>
            </a-form-item>
            <a-form-item label="见证人" v-if="info.status == 1">
                <a-input style="width: 600px" v-model="info.jianzhengren" ></a-input>
            </a-form-item>
            <a-form-item label="尺寸">
                <a-input-number style="width: 580px" v-model="info.size" ></a-input-number><span>mm</span>
            </a-form-item>
            <a-form-item label="图片">
                <img @click="openPic(info.pic)" style="max-height: 100px;cursor: pointer; margin-right: 10px;" v-if="info.pic"
                    :src="info.pic" alt="">
                <UploadFile @callback="uploaded" :mult="false" :folder="'jilu'" />
            </a-form-item>
        </a-form>
        <div class="buttons">
            <a-button type="primary" @click="doSave" >保存</a-button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.form {
    padding: 40px;
}

.sec {
    margin: 15px;
}

img {
    max-width: 100%;
}
</style>

<script>
import UploadFile from "../../components/uploadFile";

export default {
    components: { UploadFile },
    data() {
        return {
            formItemLayout: {
                labelCol: {
                    span: 3,
                },
                wrapperCol: {
                    span: 20,
                },
            },
            id: null,
            cate1List: [],
            cate2List: [],
            info: {}
        };
    },
    async created() {
        this.id = this.$route.query.id;
        await this.getDetail()
        await this.getCate1()
        await this.getCate2()
    },
    methods: {
        async getCate1() {
            const r = await this.$axios.get('/chicun/getCate1');
            if (r.status == 1) {
                this.cate1List = r.data
            }
        },
        async getCate2() {
            const r = await this.$axios.get('/chicun/getCate2?father=' + this.info.cate1);
            if (r.status == 1) {
                this.cate2List = r.data
            }
        },
        async getDetail() {
            const r = await this.$axios.get('/chicun/getLogDetail?id=' + this.id);
            if (r.status == 1) {
                this.info = r.data
            }
        },
        async changeCate1() {
            for(let item of this.cate1List) {
                if(item.id == this.info.cate1) {
                    this.info.cate1_name = item.name
                    this.info.lat_cate1_name = item.lat_name
                }
            }
            this.info.cate2 = null
            this.info.cate2_name = null
            this.info.lat_cate2_name = null
            await this.getCate2()
        },
        changeCate2() {
            for(let item of this.cate2List) {
                if(item.id == this.info.cate2) {
                    this.info.cate2_name = item.name
                    this.info.lat_cate2_name = item.lat_name
                }
            }
        },
        uploaded(e) {
            this.info.pic = this.API + e.file_path
        },
        async doSave() {
            const r = await this.$axios.post('/chicun/doSaveLog', this.info)
            if(r.status == 1) {
                this.$router.push('/chicun/logDetail?id=' + this.id)
            }
        },
        openPic(url) {
            window.open(url)
        }
    },
};
</script>